import React from 'react';
import styled from "styled-components";
const IndexHeader = styled.div`
display: flex;
grid-template-columns: 1fr;
grid-template-rows: 1fr;
align-items: center;
justify-items: center;
// padding-top: 50px;
.image {
  //min-height: 85vh;
  width: 20%;
  grid-column: 1/1;
  grid-row: 1/1;
 
}
`;
const CompanyHeader = ({ img }) => {
    return (
        <IndexHeader>
            <img src={img} alt={"KYC document exchange"} className="image" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div>
            <p  css={{'margin-bottom':'0rem'}}><font face="Arial">U-Reg helps structure a unique set of data that is essential to all KYC requests. Through</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">features and applications embedded in our platform we bring significant cost reductions and</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">improved efficiencies to market participants who today have to KYC their clients, service</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">providers or business partners. Filling KYC or regulatory questionnaires, and subsequent</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">analysis, are examples of highly repetitive tasks that can be automated through a number of</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">digital solutions, with Machine Learning and Artificial Intelligence at the core of these</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">enablers.</font></p>
                 
            </div>
        </IndexHeader>
    );
};

export default CompanyHeader;
